import { getDarkMode } from './dark';
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@mdi/font/css/materialdesignicons.min.css';
import ru from 'vuetify/src/locale/ru';

Vue.use(Vuetify);
export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#ff5722',
        secondary: '#ff9800',
        accent: '#00bcd4',
        error: '#f44336',
        warning: '#ffc107',
        info: '#009688',
        success: '#4caf50',
        background: '#FFFFFF',
        foreground: '#222222',
        header: '#FFFFFF',
        menu: '#827e7e',
      },
      dark: {
        primary: '#ff5722',
        secondary: '#ff9800',
        accent: '#00bcd4',
        error: '#f44336',
        warning: '#ffc107',
        info: '#009688',
        success: '#4caf50',
        background: '#3b3b3b',
        foreground: '#FFFFFF',
        header: '#FFFFFF',
        menu: '#FFFFFF',
      },
    },
    dark: getDarkMode(),
    options: {
      customProperties: true,
    },
  },
  icons: {
    iconfont: 'mdiSvg',
  },
  lang: {
    locales: { ru },
    current: 'ru',
  },
});
